export default __webpack_public_path__ + "static/media/Coffee-Gable-Coffee-Discovery-4.cba3abd7.jpg";